import JitsiOptionsModel from '../Models/JitsiOptionsModel'

const JitsiOptions = {
  width: '100%',
  height: '100%',
  interfaceConfigOverwrite: {
    SHOW_BRAND_WATERMARK: true,
    SHOW_WATERMARK_FOR_GUESTS: false,
    SHOW_JITSI_WATERMARK: false,
    DISABLE_VIDEO_BACKGROUND: true,
    TOOLBAR_BUTTONS: [
      'microphone',
      'camera',
      'fullscreen',
      'hangup',
      'profile',
      'info',
      'chat',
      'videoquality',
      'filmstrip',
      'tileview',
      'help',
      'desktop'
    ]
  },
  configOverwrite: {
    disableDeepLinking: true
  }
} as JitsiOptionsModel

export default JitsiOptions
